import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { LoyaltyCollectionModel } from "./LoyaltyRewardsModel";
import { getLoyaltyRewards } from "./LoyaltyRewardsServices";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<any, LoyaltyCollectionModel>;

export const DispatchLoyaltyLoading: HandlerType = props => {
    props.dispatch({
        type: "AccountPage/GetLoyaltyReward",
        result: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getLoyaltyRewards(props.parameter);
    } catch (error) {
        throw error;
    }
};

export const DispatchCompleteLoadLoyalty: HandlerType = props => {
    props.dispatch({
        type: "Accountpage/DispatchCompleteLoadLoyalty",
        loyalty: props.apiResult,
    });
};

export const chain = [DispatchLoyaltyLoading, RequestDataFromApi, DispatchCompleteLoadLoyalty];

const loadLoyaltyRewards = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        userID: "",
    },
    "loadLoyaltyRewards",
);
export default loadLoyaltyRewards;